import styled from 'styled-components';
import { FormItem } from '@xbcb/form-item-components';

export const StyledFormItem = styled(FormItem)`
  margin-bottom: ${({ theme }) => theme.spacing.space_3};
  font-size: var(--font-size-16);
  font-weight: var(--font-weight-3);
  line-height: 1.5;
  p {
    margin-bottom: 0;
  }
`;

export const StyledParagraph = styled.p`
  visibility: hidden;
`;
